import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../../core/services/theme.service';
import { Subscription } from 'rxjs';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-acceso-denegado',
  templateUrl: './acceso-denegado.component.html',
  styleUrls: ['./acceso-denegado.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class AccesoDenegadoComponent {

  constructor(
    private readonly router: Router,
    public readonly themeService: ThemeService
  ) { }

  volverAlDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}
